<template>
  <div class="card width-960 modal-hauteur-max-75vh">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="error"
                           :champsVide="champsVide"
                           :messagesChampsVide="messagesChampsVide"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <section class="columns has-text-centered">
         <div class="column">
           <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
           <p class="is-size-5 has-text-weight-bold">
                {{ $t('annulerReglement.cancel') }}
           </p>
         </div>
      </section>
      <section class="columns is-multiline is-vcentered">
        <div class="column is-4 is-offset-2">
          <b-field :label="$t('annulerReglement.dateComptable')" class="obligatoire">
            <b-datepicker
              v-model="dateComptable"
              show-week-number
              icon="calendar-today"
              :editable="true"
              append-to-body
              position="is-bottom-right"
              :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('annulerReglement.nature')">
            <b-select v-model="nature"
              expanded>
              <option :value=null>
              </option>
              <option v-for="n in constantes.natures"
                      :key="n.code"
                      :value="n.code">
                {{$t(n.libelle)}}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-8 is-offset-2">
            <parametre-autocomplete
                :label="$t('annulerReglement.motif')"
                v-model="motifId"
                :target="constantes.PARAMETRES_KEYS.motifAnnulationReglement"
                expanded
              />
          </div>
      </section>
      <section class="columns mgt-10px">
        <div class="column is-12 has-text-centered ">
            <qd-switch  v-model="isGenerateFacture">
                {{ $t('annulerReglement.generateFactureImpayee')}}
            </qd-switch>
        </div>
      </section>
      <b-table :data="lignesCommande" :bordered="true" :striped="true"
        v-if="isGenerateFacture">
          <template #empty>
            {{ $t('annulerReglement.noResult')}}
          </template>
          <b-table-column
            header-class="has-text-default"
            cell-class="is-6"
            field="libelle"
            v-slot="props"
            :label="$t('annulerReglement.table.libelle')">
            <b-input v-model="props.row.libelle" type="text"></b-input>
          </b-table-column>
          <b-table-column
            header-class="has-text-default"
            field="prixUnitaire"
            v-slot="props"
            width="200px"
            :label="$t('annulerReglement.table.montantHt')">
            <input-currency v-model="props.row.prixUnitaire"
                isNumber="true">
            </input-currency>
          </b-table-column>
          <b-table-column
            header-class="has-text-default"
            field="tauxTva"
            v-slot="props"
            width="100px"
            :label="$t('annulerReglement.table.tva')">
            <b-select v-model="props.row.tauxTva">
              <option :value="null"></option>
              <option v-for="tva in regimeTva"
                    :key="tva.tauxTva"
                    :value="tva.tauxTva">
                {{ tva.tauxTva | formatPercent }}
              </option>
            </b-select>
          </b-table-column>
          <b-table-column v-slot="props"
            width="50px">
            <div class="has-text-centered mgt-5px is-cursor-pointer"
                @click="deleteLigneCommande(props.index)">
            <b-icon type="is-danger"
                    icon="delete-forever">
            </b-icon>
            </div>
          </b-table-column>
          <template #footer>
            <div class="has-text-left">
            <button
                class="button is-primary"
                @click="addLigneCommande()">
                {{ $t('annulerReglement.table.addLine') }}
            </button>
            </div>
          </template>
       </b-table>
       <section class="mgt-10px mgb-10px" v-if="isGenerateFacture">
          <div class="columns">
            <b-field :label="$t('annulerReglement.dateFacture')"
                  class="column is-4">
              <b-datepicker show-week-number
                          icon="calendar-today"
                          :editable="true"
                          position="is-bottom-right"
                          v-model="dateFacture"
                          :nearby-selectable-month-days="true">
              </b-datepicker>
            </b-field>
            <b-field :label="$t('annulerReglement.modeReglement')"
                  class="column is-4">
              <b-select expanded v-model="modeReglementId">
                <option :value="null"></option>
                <option v-for="modeReglement in modesReglement"
                        :key="modeReglement.id"
                        :value="modeReglement.id">
                  {{modeReglement.libelle}}
                </option>
              </b-select>
            </b-field>
            <b-field :label="$t('annulerReglement.delaiReglement')"
                  class="column is-4">
                <b-select v-model="delaiReglementId"
                  expanded>
                  <option :value=null>
                  </option>
                  <option v-for="delai in delaisReglement"
                          :key="delai.id"
                          :value="delai.id">
                    {{delai.libelle}}
                  </option>
                </b-select>
            </b-field>
         </div>
       </section>
      <main>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
            @click="sendEvent('no', isGenerateFacture)">
            {{ $t('annulerReglement.no') }}
          </button>
          <button class="button is-warning has-text-centered mg-button-modal"
                  id="button-validate"
                  @click="cancelReglement()">
            {{ $t('annulerReglement.yes') }}
          </button>
        </div>
      </main>
      <footer class="subtitle modal-complement has-text-centered">
        <p>
          {{ $t('annulerReglement.info') }}
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import inputCurrency from '@/components/general/inputCurrency';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import * as devisConf from '@/configuration/devisConf';
import { SET_FACTURE } from '@/store/modules/facture-mutation-type';
import { annulerPaiementsAsync } from '@/api/mouvementClient/index';
import validationReglement from '@/services/reglement/validation/validationReglement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import getMouvementInfos from '@/services/remiseBancaire/reglement/mouvementClientReglement';
import calcul from '@/services/devisCommandes/calcul/calculCommandeDevis';
import { get } from '@/api/facture/index';
import maxOrderBaseGetter from '@/services/devisCommandes/maxOrderBaseGetter';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import messageSucces from '@/services/general/messageSucces';
import { LETTRAGE_TYPE_ANNULATION_REGLEMENT as ANNULATION_REGLEMENT, NON_LETTRE } from '@/configuration/lettrageConf';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import { LISTE_NATURE_REGLEMENT, NATURE_ANNULATION } from '@/configuration/remiseBancaire/remiseBancaireConf';
import validationGeneral from '@/services/validation/validation';
import formatIsoDate from '@/services/general/formatIsoDate';
import translate from '@/services/remiseBancaire/validation/champsRemiseBancaireTranslator';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');
const Facture = createNamespacedHelpers('facture');

export default {
  name: 'popUpAnnulationReglement',
  data() {
    return {
      isGenerateFacture: false,
      lignesCommande: [],
      dateFacture: new Date(),
      modeReglementId: null,
      delaiReglementId: null,
      newFacture: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      ancienFacture: null,
      echanceAnnuleId: null,
      constantes: {
        natures: LISTE_NATURE_REGLEMENT,
        PARAMETRES_KEYS,
      },
      nature: NATURE_ANNULATION,
      motifId: null,
      dateComptable: new Date(),
    };
  },
  components: {
    inputCurrency,
    errorMsgComponent,
    parametreAutocomplete,
  },
  props: {
    reglementAAnnuler: {
      type: Array,
      required: true,
    },
    remiseBancaire: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...societe.mapGetters({
      societeActive: 'societeActive',
      societeActiveId: 'societeActiveId',
    }),
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement;
    },
    delaisReglement() {
      return this.parametre(PARAMETRES_KEYS.delaiReglement);
    },
    motifsAnnulationsReglement() {
      return this.parametre(PARAMETRES_KEYS.motifAnnulationReglement);
    },
    regimeTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif;
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Facture.mapMutations({
      setFacture: SET_FACTURE,
    }),
    sendEvent(name, value) {
      this.$emit(name, value);
    },
    addLigneCommande() {
      this.lignesCommande.push(
        genererLigneCommande(maxOrderBaseGetter(this.lignesCommande) + 1),
      );
      const indexNouvelleValeur = this.lignesCommande.length - 1;
      miseAJourArticle(this.lignesCommande[indexNouvelleValeur], null);
    },
    deleteLigneCommande(index) {
      this.lignesCommande.splice(index, 1);
    },
    async loadFacture() {
      if (this.reglementAAnnuler[0].etatLettrage === NON_LETTRE) return;
      const mouvementClient = await getMouvementInfos(this.reglementAAnnuler[0],
        this.societeActiveId);
      const lettrage = this.reglementAAnnuler[0].lettrages[0];
      this.echanceAnnuleId = lettrage.mouvementClient1Id;
      if (this.echanceAnnuleId === this.reglementAAnnuler[0].id) {
        this.echanceAnnuleId = lettrage.mouvementClient2Id;
      }
      if (!mouvementClient.dataTable || mouvementClient.dataTable.length === 0) {
        return;
      }
      const piece = mouvementClient.dataTable[0];
      if (piece.pieceType !== mouvementClientConf.OD) {
        this.ancienFacture = (await get(piece.pieceId)).data.result;
      }
    },
    genererFacture() {
      this.newFacture = genererDevisCommande(
        devisConf.TYPE_FACTURE,
        devisConf.NORMAL,
        this.societeActive,
        devisConf.SENS_VENTE,
        devisConf.MODULE_GESTION_COMMERCIALE,
      );
      this.lignesCommande.forEach(ligneCommande => {
        ligneCommande.produitId = this.societeActive.produitIdAnnulationPaiement;
      });
      this.newFacture.theme = this.getTheme();
      this.newFacture.dateDevisCommande = this.dateFacture;
      this.newFacture.modeReglementId = this.modeReglementId;
      this.newFacture.delaiReglementId = this.delaiReglementId;
      this.newFacture.lignesCommande = this.lignesCommande;
      this.newFacture.intervenants = this.ancienFacture.intervenants;
      this.newFacture.agenceId = this.ancienFacture.agenceId;
      this.newFacture.typeReferenceExterne = ANNULATION_REGLEMENT;
      this.newFacture.referenceExterne = this.reglementAAnnuler[0].id + '|' + this.echanceAnnuleId + '|' + this.remiseBancaire.id;
      calcul(this.newFacture);
      this.setFacture(this.newFacture);
    },
    async cancelReglement() {
      this.error = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerPaiementsAsync(this.reglementAAnnuler.map(r => r.id),
          this.nature,
          this.motifId,
          formatIsoDate(this.dateComptable));
        this.$emit('updateMouvementClient');
        messageSucces(this.$t('annulerReglement.messages.success'));
        if (this.isGenerateFacture) {
          this.genererFacture();
          this.$router.push({ name: 'm.bodac.factures' });
        }
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.messages = [];
          this.messagesChampsVide = [];
          this.champsVide = [];
          validationReglement(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
    getTheme() {
      if (this.motifId) {
        return this.motifsAnnulationsReglement.find(m => {
          return m.id === this.motifId;
        }).libelle;
      }
      const natureSelected = this.constantes.natures.find(n => {
        return n.code === this.nature;
      });
      if (natureSelected) return this.$t(natureSelected.libelle);
      return null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.modeReglement,
        PARAMETRES_KEYS.delaiReglement,
        PARAMETRES_KEYS.regimeTva,
        PARAMETRES_KEYS.motifAnnulationReglement,
      ]);
      this.modeReglementId = this.remiseBancaire.modeReglementId;
      this.oldNature = this.nature;
      await this.loadFacture();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
